import { copApi } from 'api'
import { ApiResponse } from 'types/common/utils'
import { Practitioner } from 'types/practitioners'

export interface PractitionersResponse {
  records: Practitioner[]
  count: number
  total: number
}
export const fetchPractitioners = ({
  clusterId,
  page,
  limit,
  sortBy,
  sortDirection,
  communityTagsIds,
  search,
  clusterIds,
  skillIds,
  experienceIds,
  onlyFavourites,
  company,
  jobFamilyGroup,
  jobFamilyName,
}: {
  clusterId?: string
  page?: number
  limit?: number
  onlyFavourites?: boolean
  sortBy?: string[]
  sortDirection?: 'ASC' | 'DESC'
  communityTagsIds?: string[]
  search?: string
  clusterIds?: string[]
  skillIds?: string[]
  experienceIds?: string[]
  company?: string
  // department.name
  jobFamilyGroup?: string
  // jobFamily.name
  jobFamilyName?: string
}) =>
  copApi.get<ApiResponse<Practitioner>>('/practitioners', {
    params: {
      clusterId,
      page,
      limit,
      sortField: !!sortBy ? sortBy : undefined,
      sortDirection: !!sortBy && !!sortDirection ? [sortDirection] : undefined,
      communityTagIds: communityTagsIds,
      search: search || undefined,
      clusterIds: clusterIds || undefined,
      skillIds: skillIds || undefined,
      experienceIds: experienceIds || undefined,
      onlyFavourites: onlyFavourites ? true : undefined,
      company: company || undefined,
      jobFamilyGroup: jobFamilyGroup || undefined,
      jobFamilyName: jobFamilyName || undefined,
    },
  })
